import React from "react";
import * as Styled from "./styles";
import ButtonPrimary from "Components/Buttons/Primary";

interface Props {
  field: string;
  message: string;
  onLogin: () => void;
  onCancel: () => void;
}

const UserExistsModal: React.FC<Props> = ({
  field,
  message,
  onLogin,
  onCancel,
}) => {
  console.log("received field:", field);
  console.log("received message:", message);

  const fieldLabel =
    field === "email" ? "email" : field === "cpf" ? "CPF" : "CNPJ";

  return (
    <Styled.Overlay>
      <Styled.Modal>
        <Styled.Title>Usuário já cadastrado</Styled.Title>
        <Styled.Message>
          {message || `Já existe um usuário cadastrado com este ${fieldLabel}.`}
        </Styled.Message>
        <Styled.Question>
          Deseja fazer login com este usuário para vincular à loja ou tentar
          outro {fieldLabel}?
        </Styled.Question>
        <Styled.ButtonContainer>
          <ButtonPrimary action={onLogin} color="green">
            Fazer Login
          </ButtonPrimary>
          <Styled.CancelButton onClick={onCancel}>
            Tentar outro {fieldLabel}
          </Styled.CancelButton>
        </Styled.ButtonContainer>
      </Styled.Modal>
    </Styled.Overlay>
  );
};

export default UserExistsModal;
